import { useMemo } from 'react';

import { useLocation, useMatches } from '@tanstack/react-router';

export function useCurrentLocation() {
  const location = useLocation();
  const { pathname } = location;
  const matches = useMatches();

  const { matched, useablePath } = useMemo(() => {
    const _matches = matches.filter((m) => {
      return m.pathname.replace(/\/$/, '') === pathname.replace(/\/$/, '');
    });
    const _matched = _matches[_matches.length - 1];
    const fullPath = _matched?.fullPath?.replace(/\/$/, '');
    return { matched: _matched, useablePath: fullPath };
  }, [matches, pathname]);

  return { location, matches, matched, useablePath };
}
